<template>
  <div class="team-intr">
    <OrgMapDev></OrgMapDev>
  </div>
</template>

<script>
import OrgMapDev from './orgMapDev'
export default {
  components:{
    OrgMapDev
  },
  data(){
    return{
    }
  }
}
</script>